import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono text-xs font-medium uppercase tracking-[0.22em] ${
      dark ? "text-[#EAB308]" : "text-[#0A3B2C]"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-[#EAB308]" : "bg-[#0A3B2C]"}`} />
    {children}
  </span>
);
